"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuth = void 0;
var OAuth;
(function (OAuth) {
    OAuth.loginSucceeded = 'oauth_result:login_succeeded';
    OAuth.canceled = 'oauth_result:canceled';
    OAuth.anotherAccountExists = 'oauth_result:another_account_exists';
    OAuth.stateUnmatched = 'oauth_result:state_unmatched';
    OAuth.unknown = 'oauth_result:unknown';
    var results = new Set([OAuth.loginSucceeded, OAuth.canceled, OAuth.stateUnmatched, OAuth.anotherAccountExists, OAuth.unknown]);
    function isOAuthResult(value) {
        return results.has(value);
    }
    OAuth.isOAuthResult = isOAuthResult;
})(OAuth = exports.OAuth || (exports.OAuth = {}));
//# sourceMappingURL=oauth.js.map